







































































































































































































































































































































































































































































































































































import { Component, Prop, PropSync, Vue, Watch } from 'vue-property-decorator';
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
import { namespace } from 'vuex-class';
import { vuex } from "@/store";
import _ from 'lodash';
import rest from '@/rest';
import { signalrEventBus } from '@/main';
import { List } from 'linq-collections';

import { l3draggable, DraggableOptions } from '@/directives/l3dragDrop';
import draggable from 'vuedraggable';
// components
import AiVideoScenesWizardDlg from './AiVideoScenesWizardDlg.vue';
import L3FrameWithTitle from '@/components/Shared/L3FrameWithTitle.vue';
import SimpleMessageBox from '@/components/Shared/SimpleMessageBox.vue';
import ExpandableCard from '@/components/Shared/ExpandableCard.vue';
import ImageWithDnD from '@/components/Shared/ImageWithDnD.vue';
import SceneItem from './SceneItem.vue';

// interfaces
import { FileDetailsVm } from '@/interfaces/FileDetailsVm';
import { AiVideoCreatorVm, AiVideoSceneVm } from '@/interfaces/AiVideoCreatorVm';
import { CourseElementVm } from '@/interfaces/CourseElementVm';
import { ParamDictionary } from '@/interfaces/ParamDictionary';
import { CustomizationVm, VideoGenerationService } from '@/interfaces/CustomizationVm';
import { ParamVideoScene } from '@/interfaces/ParamVideoScene';
import VideoWithDnD from '@/components/Shared/VideoWithDnD.vue';
import BackgroundAudioWithDnD from '@/components/Shared/BackgroundAudioWithDnD.vue';

const globals = namespace("globals");
const ux = namespace("ux");
const customization = namespace("customization");

@Component({
  components: {
    AiVideoScenesWizardDlg,
    L3FrameWithTitle,
    ExpandableCard,
    ImageWithDnD,
    VideoWithDnD,
    BackgroundAudioWithDnD,
    SceneItem,
    draggable,
    SimpleMessageBox
  },
  directives: { l3draggable }
})
export default class AiVideoCreatorDlg extends Vue {
  @PropSync("showDialog") syncedShowDialog!: boolean;
  @PropSync("videoElement") syncedVideoElement!: CourseElementVm;
  @customization.Getter customizationSettings!: CustomizationVm;
  @globals.Getter selectedBundle: any;
  @globals.Getter selectedExercise: any;
  @globals.Action refreshSelectedElement!: () => Promise<void>;
  @ux.Getter gradientBackground: any;
  @ux.Getter gradientBackground2: any;
  @ux.Getter gradientBackground3: any;
  @ux.Getter gradientText: any;
  @ux.State darkTheme: any;

  isBusySavingData = false;
  isBusyCreatingStartFrame = false;
  isBusyCreatingVideo = false;
  isBusyMergingVideo = false;
  isValid = false;
  showConfirmationDialog = false;
  showImportDialog = false;
  showVideoScenesWizardDlg = false;
  showConfirmDeleteSceneVideoDialog = false;
  showMaxSelectionDialog = false;
  importText = '';
  clipboardCopied = false;
  fileWithSummarySelected = false;
  formData: AiVideoCreatorVm | null = null;
  originalFormData: AiVideoCreatorVm | null = null;
  selectedScene: AiVideoSceneVm | null = null;
  selectedActionPanel: number = 0;
  // fileList: FileDetailsVm[] | null = null;
  // chatMessages: ChatMessageVm[] = [];
  sceneVideoId = "";
  newVideoUrl = "";
  videoCreationProgress = 0;

  mergedVideoId = "";
  mergedVideoUrl = "";

  $refs!: {
    // mediaPool: MediaPool;
  };

  // temp holder for placeholder image input
  placeholderActorImage: string | null = null;
  placeholderSceneryImage: string | null = null;
  placeholderObjectImage: string | null = null;

  created() {
    // SignalR event listener
    signalrEventBus.$on('backgroundTaskEvent', this.backgroundTaskEvent);
  }

  beforeDestroy() {
    // clearAllBodyScrollLocks();
    // Make sure to cleanup SignalR event handlers when removing the component
    signalrEventBus.$off('backgroundTaskEvent', this.backgroundTaskEvent);
  }

  // SignalR events
  async backgroundTaskEvent(response: { id: string, progress: number, message: string, status: string }) {
    if (this.sceneVideoId == response.id) {
      console.log("AiVideoCreatorDlg > Background task event:", response);

      if (response.status == "INF") {
        this.videoCreationProgress = response.progress;
        return;
      }

      await this.refreshSelectedElement();
      this.videoCreationProgress = 0;
      this.isBusyCreatingVideo = false;

      if (response.status == "SUC") {
        // Add new video file to scene's video files
        if (!this.selectedScene!.sceneVideoFiles) this.selectedScene!.sceneVideoFiles = [];
        const newVideoFile = <FileDetailsVm>{
          id: this.selectedScene!.sceneVideoFiles.length + 1,
          guid: this.$globalHelper.getNewGuid(),
          name: null,
          newName: null,
          filePath: this.newVideoUrl,
          fileType: 'Video',
          isDirectory: false,
          isScormDir: false,
          size: 0,
          hasAiSummary: false,
          aiSummary: null,
          isBusy: false,
          isSelected: false,
          prompt: null,
          changePrompt: null,
          altText: null,
          imageLibrarySearchText: null
        } as any;
        this.selectedScene!.sceneVideoFiles.push(newVideoFile);
        // update ids
        this.selectedScene!.sceneVideoFiles.forEach((f, idx) => {
          f.id = idx + 1;
        });
        this.selectedScene!.selectedSceneVideoFileId = newVideoFile.id;
        // this.syncedShowDialog = false;
      }
    }

    if (this.mergedVideoId == response.id) {
      console.log("AiVideoCreatorDlg > Background task event:", response);

      // if (response.status == "INF") {
      //   this.videoCreationProgress = response.progress;
      //   return;
      // }

      await this.refreshSelectedElement();
      this.isBusyMergingVideo = false;

      if (response.status == "SUC") {
        this.syncedVideoElement.contentUrl = this.mergedVideoUrl;
        this.syncedShowDialog = false;
      }
    }
  }

  @Watch("syncedShowDialog")
  async onShowDialogChanged(val: boolean) {
    if (this.syncedShowDialog) {
      // On dialog open
      this.isBusySavingData = false;
      this.isBusyCreatingStartFrame = false;
      this.isBusyCreatingVideo = false;
      this.videoCreationProgress = 0;
      this.isBusyMergingVideo = false;
      this.selectedScene = null;
      this.selectedActionPanel = 0;

      await this.loadAiVideoData();
      // console.log("AiVideoCreatorDlg: Language ", this.formData?.language);
      // this.onFileSelectionChanged();
      // if (this.formData && !this.formData.language) {
      //   // Default language code (Deutsch)
      //   console.log("AiVideoCreatorDlg: Setting default language code to de-DE");
      //   this.formData!.language = "de-DE";
      // }
      // Disable body scroll on iOS
      this.$nextTick(async () => {
        await this.$globalHelper.delay(10);
        const modal = document.querySelector('.modal');
        disableBodyScroll(modal);
      });
    } else {
      // Dialog closing
      clearAllBodyScrollLocks();
    }
  }

  async loadAiVideoData() {
    this.isBusySavingData = true;
    let params = <ParamDictionary>{dictionary: {}};
    params.dictionary!["BundleId"] = this.selectedBundle.id.toString();
    params.dictionary!["ExerciseId"] = this.selectedExercise.id.toString();
    params.dictionary!["FileName"] = this.syncedVideoElement.file!;
    params.dictionary!["ElementGuid"] = this.syncedVideoElement.guid!;

    this.formData = null;
    await rest.url("contentManager/loadAiVideoCreatorData")
      .post(params)
      .then((response) => {
        // console.log("AiVideoCreatorDlg - loadAiVideoData language:", response?.language);
        this.formData = response;
        this.formData!.bundleId = this.selectedBundle.id;
        // Select first scene by default
        if (this.formData && this.formData.scenes && this.formData.scenes.length > 0) {
          this.selectScene(0);
        }

        // Keep a deep copy of the loaded data to detect unsaved changes
        this.originalFormData = _.cloneDeep(this.formData);
        // console.log("AiVideoCreatorDlg - loadAiVideoData:", this.formData);
        // console.log("AiVideoCreatorDlg - originalFormData:", this.originalFormData);
      })
      .finally(() => {
        this.isBusySavingData = false;
      });
  }

  async saveAiVideoData() {
    this.isBusySavingData = true;
    if (this.customizationSettings.enableAi) {
    }

    // this.syncedVideoElement.title = this.formData?.title || '';
    // this.syncedVideoElement.text = this.formData?.text || '';

    await rest.url("contentManager/saveAiVideoCreatorData")
      .post(this.formData)
      .then((response) => {
        // this.formData = response;
        // Update actor/scenery/object files with new data from backend (file by file)
        if (this.formData) {
          // this.updateFilesWithResponseData(this.formData.actorFiles!, response.actorFiles);
          // this.updateFilesWithResponseData(this.formData.sceneryFiles!, response.sceneryFiles);
          // this.updateFilesWithResponseData(this.formData.objectFiles!, response.objectFiles);
          this.updateFilesWithResponseData(this.formData.assetFiles!, response.assetFiles);
        }
        // After a successful save, update the original snapshot so further closes don't prompt
        this.originalFormData = _.cloneDeep(this.formData);
      })
      .finally(() => {
        this.isBusySavingData = false;
      });
  }

  updateFilesWithResponseData(currentFiles: FileDetailsVm[], responseFiles: FileDetailsVm[]) {
    if (!currentFiles || !responseFiles) return;

    for (let i = 0; i < currentFiles.length; i++) {
      const currentFile = currentFiles![i];
      const matchingResponseFile = responseFiles.find(f => f.guid === currentFile.guid);
      if (matchingResponseFile) {
        // Update only the properties that might have changed on the backend
        currentFile.id = matchingResponseFile.id;
        currentFile.name = matchingResponseFile.name;
        currentFile.filePath = matchingResponseFile.filePath;
      }
    }
  }

  // Asset files (common for actors, scenery and objects)
  get actorFiles() {
    return this.formData?.assetFiles?.filter(f => f.fileType === "Actor") || [];
  }

  get sceneryFiles() {
    return this.formData?.assetFiles?.filter(f => f.fileType === "Scenery") || [];
  }

  get objectFiles() {
    return this.formData?.assetFiles?.filter(f => f.fileType === "Object") || [];
  }

  get aiVideoSupportForMultipleFileSelection() {
    if (!this.customizationSettings) return false;
    return this.customizationSettings.videoGenerationService == VideoGenerationService.GoogleVeo &&
      this.customizationSettings.videoGenerationModel == "veo-3.1-fast-generate-001";
  }

  // Actor files
  @Watch('placeholderActorImage')
  watchPlaceholderActorImage(val: string | null) {
    if (val) this.onActorPlaceholderImageUpdated(val);
  }

  onActorPlaceholderImageUpdated(imagePath: string | null) {
    if (!imagePath) return;
    if (!this.formData) return;
    if (!this.formData.assetFiles) this.formData.assetFiles = [];
    // console.log("Adding new actor file with path:", imagePath);

    const newFile: FileDetailsVm = {
      id: this.formData.assetFiles.length > 0 ? Math.max(...this.formData.assetFiles.map((f) => f.id ?? 0)) + 1 : 1,
      guid: this.$globalHelper.getNewGuid(),
      name: null,
      newName: null,
      filePath: imagePath,
      fileType: 'Actor',
      isDirectory: false,
      isScormDir: false,
      size: 0,
      hasAiSummary: false,
      aiSummary: null,
      isBusy: false,
      isSelected: false,
      prompt: null,
      changePrompt: null,
      altText: null,
      imageLibrarySearchText: null
    } as any;

    this.formData.assetFiles.push(newFile);
    // reset placeholder
    this.placeholderActorImage = null;
  }

  async onDeleteFile(file: FileDetailsVm) {
    if (!this.formData || !this.formData.assetFiles) return;
      const fileToDelete = this.formData.assetFiles.find(f => f.guid === file.guid);
      if (fileToDelete?.filePath)
        await this.onDeleteFileOrDirectory(fileToDelete);

    this.formData.assetFiles = this.formData.assetFiles.filter(f => f.guid !== file.guid);
  }

  // Scenery files
  @Watch('placeholderSceneryImage')
  watchPlaceholderSceneryImage(val: string | null) {
    if (val) this.onSceneryPlaceholderImageUpdated(val);
  }

  onSceneryPlaceholderImageUpdated(imagePath: string | null) {
    if (!imagePath) return;
    if (!this.formData) return;
    if (!this.formData.assetFiles) this.formData.assetFiles = [];

    const newFile = <FileDetailsVm>{
      id: this.formData.assetFiles.length > 0 ? Math.max(...this.formData.assetFiles.map((f) => f.id ?? 0)) + 1 : 1,
      guid: this.$globalHelper.getNewGuid(),
      name: null,
      newName: null,
      filePath: imagePath,
      fileType: 'Scenery',
      isDirectory: false,
      isScormDir: false,
      size: 0,
      hasAiSummary: false,
      aiSummary: null,
      isBusy: false,
      isSelected: false,
      prompt: null,
      changePrompt: null,
      altText: null,
      imageLibrarySearchText: null
    } as any;

    this.formData.assetFiles.push(newFile);
    // reset placeholder
    this.placeholderSceneryImage = null;
  }

  // async onDeleteSceneryFile(idx: number) {
  //   if (!this.formData || !this.formData.sceneryFiles) return;
  //     const fileToDelete = this.formData.sceneryFiles[idx];
  //     if (fileToDelete?.filePath)
  //       await this.onDeleteFileOrDirectory(fileToDelete);

  //   this.formData.sceneryFiles.splice(idx, 1);
  // }

  // Object files
  @Watch('placeholderObjectImage')
  watchPlaceholderObjectImage(val: string | null) {
    if (val) this.onObjectPlaceholderImageUpdated(val);
  }

  onObjectPlaceholderImageUpdated(imagePath: string | null) {
    if (!imagePath) return;
    if (!this.formData) return;
    if (!this.formData.assetFiles) this.formData.assetFiles = [];

    const newFile = <FileDetailsVm>{
      id: this.formData.assetFiles.length > 0 ? Math.max(...this.formData.assetFiles.map((f) => f.id ?? 0)) + 1 : 1,
      guid: this.$globalHelper.getNewGuid(),
      name: null,
      newName: null,
      filePath: imagePath,
      fileType: 'Object',
      isDirectory: false,
      isScormDir: false,
      size: 0,
      hasAiSummary: false,
      aiSummary: null,
      isBusy: false,
      isSelected: false,
      prompt: null,
      changePrompt: null,
      altText: null,
      imageLibrarySearchText: null
    } as any;

    this.formData.assetFiles.push(newFile);
    this.placeholderObjectImage = null;
  }

  // async onDeleteObjectFile(idx: number) {
  //   if (!this.formData || !this.formData.objectFiles) return;
  //     const fileToDelete = this.formData.objectFiles[idx];
  //     if (fileToDelete?.filePath)
  //       await this.onDeleteFileOrDirectory(fileToDelete);

  //   this.formData.objectFiles.splice(idx, 1);
  // }

  @Watch('selectedScene.extendPreviousScene')
  onExtendPreviousSceneChanged(val: boolean) {
    if (val) this.selectedActionPanel = 1;
  }

  get isVideoPanelSelected() {
    return this.selectedActionPanel === 1;
  }

  get assetSelectionCheckboxColor() {
    return this.selectedActionPanel === 1 ? this.$store.state.ux.colorAccent9 : this.$store.state.ux.colorAccent;
  }

  // watch selectedActionPanel and call selectAssetFilesForSelectedScene
  @Watch('selectedActionPanel')
  onSelectedActionPanelChanged() {
    this.selectAssetFilesForSelectedScene();
  }

  @Watch('formData', { deep: true })
  watchFormDataFiles(val: AiVideoCreatorVm | null) {
    if (this.formData && this.formData.assetFiles) {
      // remove entries with empty filePath
      // for (let i = this.formData.assetFiles.length - 1; i >= 0; i--) {
      //   const f = this.formData.assetFiles[i];
      //   if (!f || !f.filePath) {
      //     this.formData.assetFiles.splice(i, 1);
      //     this.removeUnavailableFileFromScenes();
      //   }
      // }
      // update ids
      this.formData.assetFiles.forEach((f, idx) => {
        f.id = idx + 1;
      });
    }
    // if (this.formData && this.formData.sceneryFiles) {
    //   // remove entries with empty filePath
    //   // for (let i = this.formData.sceneryFiles.length - 1; i >= 0; i--) {
    //   //   const f = this.formData.sceneryFiles[i];
    //   //   if (!f || !f.filePath) {
    //   //     this.formData.sceneryFiles.splice(i, 1);
    //   //     this.removeUnavailableFileFromScenes();
    //   //   }
    //   // }
    //   // update ids
    //   this.formData.sceneryFiles.forEach((f, idx) => {
    //     f.id = idx + 1;
    //   });
    // }
    // if (this.formData && this.formData.objectFiles) {
    //   // remove entries with empty filePath
    //   // for (let i = this.formData.objectFiles.length - 1; i >= 0; i--) {
    //   //   const f = this.formData.objectFiles[i];
    //   //   if (!f || !f.filePath) {
    //   //     this.formData.objectFiles.splice(i, 1);
    //   //     this.removeUnavailableFileFromScenes();
    //   //   }
    //   // }
    //   // update ids
    //   this.formData.objectFiles.forEach((f, idx) => {
    //     f.id = idx + 1;
    //   });
    // }
  }

  // removeUnavailableFileFromScenes() {
  //   if (!this.formData || !this.formData.scenes) return;

  //   const allAvailableFiles = new Set<string>();
  //   if (this.formData.actorFiles) {
  //     this.formData.actorFiles.forEach(f => {
  //       if (f.filePath) allAvailableFiles.add(f.filePath);
  //     });
  //   }
  //   if (this.formData.sceneryFiles) {
  //     this.formData.sceneryFiles.forEach(f => {
  //       if (f.filePath) allAvailableFiles.add(f.filePath);
  //     });
  //   }
  //   if (this.formData.objectFiles) {
  //     this.formData.objectFiles.forEach(f => {
  //       if (f.filePath) allAvailableFiles.add(f.filePath);
  //     });
  //   }

  //   this.formData.scenes.forEach(scene => {
  //     if (scene.selectedActorFiles) {
  //       scene.selectedActorFiles = scene.selectedActorFiles.filter((filePath: string) => allAvailableFiles.has(filePath));
  //     }
  //     if (scene.selectedSceneryFiles) {
  //       scene.selectedSceneryFiles = scene.selectedSceneryFiles.filter((filePath: string) => allAvailableFiles.has(filePath));
  //     }
  //     if (scene.selectedObjectFiles) {
  //       scene.selectedObjectFiles = scene.selectedObjectFiles.filter((filePath: string) => allAvailableFiles.has(filePath));
  //     }
  //   });
  // }

  async onCreateStartFrame() {
    if (!this.formData || !this.selectedScene) return;

    try {
      this.isBusyCreatingStartFrame = true;
      await this.saveAiVideoData();

      let params: ParamVideoScene = {
        bundleId: this.selectedBundle.id,
        elementGuid: this.syncedVideoElement.guid!,
        fileName: this.formData.fileName!,
        scene: this.selectedScene
      };
      let response = await rest.url("contentManager/createSceneStartFrame").post(params);

      if (response && response.previewImage) {
        // this.selectedScene.previewImage = response.previewImage;
        // add as new start frame file to scene
        if (!this.selectedScene.startFrameFiles) this.selectedScene.startFrameFiles = [];
        // use selected start frame file if exists and has no filePath (means it was just a placeholder for creation)
        if (!this.selectedSceneStartFrameFile?.filePath) {
          this.selectedSceneStartFrameFile!.filePath = response.previewImage;
          return;
        }
        // otherwise add new start frame file to end of list and select it
        const newStartFrameFile = <FileDetailsVm>{
          id: this.selectedScene.startFrameFiles!.length + 1,
          guid: this.$globalHelper.getNewGuid(),
          name: null,
          newName: null,
          filePath: response.previewImage,
          fileType: 'Image',
          isDirectory: false,
          isScormDir: false,
          size: 0,
          hasAiSummary: false,
          aiSummary: null,
          isBusy: false,
          isSelected: false,
          prompt: null,
          changePrompt: null,
          altText: null,
          imageLibrarySearchText: null
        } as any;
        this.selectedScene.startFrameFiles.push(newStartFrameFile);
        // update ids
        this.selectedScene.startFrameFiles.forEach((f, idx) => {
          f.id = idx + 1;
        });
        this.selectedScene.selectedStartFrameFileId = newStartFrameFile.id;
      }
    } catch (e) {
      console.error("Error creating key frame:", e);
    } finally {
      this.isBusyCreatingStartFrame = false;
    }
  }

  async onCreateVideo() {
    if (!this.formData || this.isBusyCreatingVideo) return;
    this.isBusyCreatingVideo = true;

    await this.$l3rnOnlineHub.ensureConnection();
    this.formData.signalRClientId =  this.$l3rnOnlineHub.ConnectionId!;
    await this.saveAiVideoData();

    let params: ParamVideoScene = {
      bundleId: this.selectedBundle.id,
      elementGuid: this.syncedVideoElement.guid!,
      fileName: this.formData.fileName!,
      scene: this.selectedScene
    };

    try {
      let response = await rest.url("contentManager/createSceneVideo").post(params);
      if (response && response.videoUrl) {
        // this.selectedScene!.videoUrl = null; // reset video url to force reload if user creates another video with same name
        // await this.$globalHelper.delay(10); // small delay to ensure the old video is released before loading the new one
        // this.selectedScene!.videoUrl = response.videoUrl;

        this.newVideoUrl = response.videoUrl ?? "";
        this.sceneVideoId = this.$globalHelper.extractFileName(response.videoUrl ?? "");

        // Add new video file to scene's video files
        // if (!this.selectedScene!.sceneVideoFiles) this.selectedScene!.sceneVideoFiles = [];
        // const newVideoFile = <FileDetailsVm>{
        //   id: this.selectedScene!.sceneVideoFiles.length + 1,
        //   guid: this.$globalHelper.getNewGuid(),
        //   name: null,
        //   newName: null,
        //   filePath: response.videoUrl,
        //   fileType: 'Video',
        //   isDirectory: false,
        //   isScormDir: false,
        //   size: 0,
        //   hasAiSummary: false,
        //   aiSummary: null,
        //   isBusy: false,
        //   isSelected: false,
        //   prompt: null,
        //   changePrompt: null,
        //   altText: null,
        //   imageLibrarySearchText: null
        // } as any;
        // this.selectedScene!.sceneVideoFiles.push(newVideoFile);
        // // update ids
        // this.selectedScene!.sceneVideoFiles.forEach((f, idx) => {
        //   f.id = idx + 1;
        // });
        // this.selectedScene!.selectedSceneVideoFileId = newVideoFile.id;
      }
    } catch (e) {
      console.error("Error creating video:", e);
    } finally {
      // this.isBusyCreatingVideo = false;
    }
  }

  async onMergeSceneVideos() {
    if (!this.formData || this.isBusyCreatingVideo) return;
    this.isBusyMergingVideo = true;

    await this.$l3rnOnlineHub.ensureConnection();
    this.formData.signalRClientId =  this.$l3rnOnlineHub.ConnectionId!;
    await this.saveAiVideoData();

    try {
      let response = await rest.url("contentManager/mergeSceneVideos").post(this.formData);
      if (response && response.videoUrl) {
        this.mergedVideoUrl = response.videoUrl ?? "";
        this.mergedVideoId = this.$globalHelper.extractFileName(response.videoUrl ?? "");
        // console.log("AiVideoCreatorDlg > onMergeSceneVideos: mergedVideoId:", this.mergedVideoId);
      }
    } catch (e) {
      console.error("Error merging scene videos:", e);
    } finally {
      // this.isBusyMergingVideo = false;
    }
  }

  async onClose() {
    // If we don't have loaded data, just close
    if (!this.formData || !this.originalFormData) {
      this.$emit('closed:AiVideoCreator');
      this.syncedShowDialog = false;
      return;
    }

    // If nothing changed, close immediately
    if (_.isEqual(this.formData, this.originalFormData)) {
      this.$emit('closed:AiVideoCreator');
      this.syncedShowDialog = false;
      return;
    }

    // Otherwise ask for confirmation
    this.showConfirmationDialog = true;
  }

  async onCloseEditor(save: boolean) {
    this.showConfirmationDialog = false;
    if (save) {
      await this.saveAiVideoData();
    }
    this.$emit('closed:AiVideoCreator');
    this.syncedShowDialog = false;
  }

  // onActorImageChanged(index: number, imagePath: string | null) {
  //   if (!this.formData || !this.formData.actorFiles) return;
  //   if (imagePath) {
  //     // update existing file path
  //     this.$set(this.formData.actorFiles[index], 'filePath', imagePath);
  //   } else {
  //     // if image cleared, remove the file entry
  //     this.formData.actorFiles.splice(index, 1);
  //   }
  // }

  toggleSelection(file: FileDetailsVm) {
    if (!this.formData || !this.formData.assetFiles || !this.selectedScene) return;
    const f = this.formData.assetFiles.find(asset => asset.guid === file.guid);
    if (!f) return;

    const maxVideoSelection = 3;
    const currentlySelectedCount = this.formData.assetFiles.filter(asset => asset.isSelected).length;
    const requestedSelectionState = !f.isSelected;

    if (this.isVideoPanelSelected && requestedSelectionState && !f.isSelected && currentlySelectedCount >= maxVideoSelection) {
      this.showMaxSelectionDialog = true;
      return;
    }

    this.$set(f, 'isSelected', requestedSelectionState);
    if (this.isVideoPanelSelected) {
      this.selectedScene.selectedFileGuidsForVideo = this.formData.assetFiles
        .filter(asset => asset.isSelected)
        .map(asset => asset.guid!);
    } else {
      this.selectedScene.selectedFileGuidsForStartFrame = this.formData.assetFiles
        .filter(asset => asset.isSelected)
        .map(asset => asset.guid!);
    }
  }

  get startImageDisabled() {
    if (!this.formData || !this.formData.assetFiles || !this.selectedScene) return false;
    return (this.selectedScene.selectedFileGuidsForVideo?.length ?? 0) > 0;
  }

  poolItemDragOptions(file: any) {
    return <DraggableOptions>{
      data: { fileType: 'Image', filePath: file.filePath },
      dragClass: 'dragging',
      targetGroups: ['image-file-details'],
      onDragStart: (ev: DragEvent) => {
        const handle = ev.currentTarget as HTMLElement;
        const card = handle?.parentElement;
        if (card && ev.dataTransfer) {
          // Clone to body: setDragImage requires position:fixed so Chrome renders it;
          // getBoundingClientRect() forces layout before the ghost is captured.
          const clone = card.cloneNode(true) as HTMLElement;
          clone.style.cssText = `position:fixed;top:0;left:-9999px;width:${card.offsetWidth}px;pointer-events:none`;
          document.body.appendChild(clone);
          void clone.getBoundingClientRect();
          ev.dataTransfer.setDragImage(clone, card.offsetWidth / 2, 20);
          setTimeout(() => document.body.removeChild(clone), 0);
        }
      }
    };
  }

  // Start frame files
  get selectedSceneStartFrameFile() {
    if (!this.selectedScene || !this.selectedScene.startFrameFiles) return null;
    // If no file is available, add one
    if (this.selectedScene.startFrameFiles.length === 0) {
      const newFile = {
        id: 1,
        name: null,
        newName: null,
        filePath: null,
        fileType: 'Image',
        isDirectory: false,
        isScormDir: false,
        size: 0,
        hasAiSummary: false,
        aiSummary: null,
        isBusy: false,
        isSelected: false,
        prompt: null,
        changePrompt: null,
        altText: null,
        imageLibrarySearchText: null
      } as any;
      this.selectedScene.startFrameFiles.push(newFile);
      this.selectedScene.selectedStartFrameFileId = newFile.id;
    }

    return this.selectedScene.startFrameFiles.find((f: any) => f.id === this.selectedScene!.selectedStartFrameFileId) || null;
  }

  addNewStartFrameFile() {
    if (!this.selectedScene) return;
    if (!this.selectedScene.startFrameFiles) this.selectedScene.startFrameFiles = [];
    // const newId = this.selectedScene.startFrameFiles.length > 0 ? Math.max(...this.selectedScene.startFrameFiles.map((f: any) => f.id ?? 0)) + 1 : 1;
    const newFile = {
      id: this.selectedScene.startFrameFiles.length + 1,
      name: null,
      newName: null,
      filePath: null,
      fileType: 'Image',
      isDirectory: false,
      isScormDir: false,
      size: 0,
      hasAiSummary: false,
      aiSummary: null,
      isBusy: false,
      isSelected: false,
      prompt: null,
      changePrompt: null,
      altText: null,
      imageLibrarySearchText: null
    } as any;
    this.selectedScene.startFrameFiles.push(newFile);
    // write new ids to all files
    this.selectedScene.startFrameFiles.forEach((f: any, idx: number) => {
      f.id = idx + 1;
    });
    this.selectedScene.selectedStartFrameFileId = newFile.id;
  }

  async onDeleteStartFrameFile() {
    if (!this.selectedScene || !this.selectedScene.startFrameFiles) return;
    const idx = this.selectedSceneStartFrameFileIndex;
    const fileToDelete = this.selectedScene.startFrameFiles[idx];
    if (idx >= 0) {
      // before removing the file, select next or previous file to avoid having selectedStartFrameFileId pointing to a non-existing file
      if (idx < this.selectedScene.startFrameFiles.length - 1) {
        const next = this.selectedScene.startFrameFiles[idx + 1];
        if (next) this.selectedScene.selectedStartFrameFileId = next.id;
      } else if (idx > 0) {
        const prev = this.selectedScene.startFrameFiles[idx - 1];
        if (prev) this.selectedScene.selectedStartFrameFileId = prev.id;
      } else {
        this.selectedScene.selectedStartFrameFileId = 0;
      }

      // Call onDeleteFileOrDirectory to remove the file from the server and then remove the file entry
      await this.onDeleteFileOrDirectory(fileToDelete);
      this.selectedScene.startFrameFiles.splice(idx, 1);
      // write new ids to all files
      this.selectedScene.startFrameFiles.forEach((f: any, idx: number) => {
        f.id = idx + 1;
      });
    }
  }

  get selectedSceneStartFrameFileIndex() {
    if (!this.selectedScene || !this.selectedScene.startFrameFiles) return 0;
    const idx = this.selectedScene.startFrameFiles.findIndex((f: any) => f.id === this.selectedScene!.selectedStartFrameFileId);
    return idx >= 0 ? idx : 0;
  }

  hasPreviousStartFrameFile() {
    return !!(this.selectedScene && this.selectedScene.startFrameFiles && this.selectedScene.startFrameFiles.length > 0 && this.selectedSceneStartFrameFileIndex > 0);
  }

  selectPreviousStartFrameFile() {
    if (!this.selectedScene || !this.selectedScene.startFrameFiles) return;
    const idx = this.selectedSceneStartFrameFileIndex;
    if (idx > 0) {
      const prev = this.selectedScene.startFrameFiles[idx - 1];
      if (prev) this.selectedScene.selectedStartFrameFileId = prev.id;
    }
  }

  hasNextStartFrameFile() {
    return !!(this.selectedScene && this.selectedScene.startFrameFiles && this.selectedScene.startFrameFiles.length > 0 && this.selectedSceneStartFrameFileIndex < this.selectedScene.startFrameFiles.length - 1);
  }

  selectNextStartFrameFile() {
    if (!this.selectedScene || !this.selectedScene.startFrameFiles) return;
    const idx = this.selectedSceneStartFrameFileIndex;
    if (idx < this.selectedScene.startFrameFiles.length - 1) {
      const next = this.selectedScene.startFrameFiles[idx + 1];
      if (next) this.selectedScene.selectedStartFrameFileId = next.id;
    }
  }

  // Scene video files
  get selectedSceneVideoFileIndex() {
    if (!this.selectedScene || !this.selectedScene.sceneVideoFiles) return -1;
    const idx = this.selectedScene.sceneVideoFiles.findIndex((f: any) => f.id === this.selectedScene!.selectedSceneVideoFileId);
    return idx >= 0 ? idx : -1;
  }

  get selectedSceneVideoFile() {
    if (!this.selectedScene || !this.selectedScene.sceneVideoFiles) return null;
    return this.selectedScene.sceneVideoFiles.find((f: any) => f.id === this.selectedScene!.selectedSceneVideoFileId) || null;
  }

  addNewSceneVideoFile() {
    if (!this.selectedScene) return;
    if (!this.selectedScene.sceneVideoFiles) this.selectedScene.sceneVideoFiles = [];
    const newId = this.selectedScene.sceneVideoFiles.length > 0 ? Math.max(...this.selectedScene.sceneVideoFiles.map((f: any) => f.id ?? 0)) + 1 : 1;
    const newFile = {
      id: newId,
      name: null,
      newName: null,
      filePath: null,
      fileType: 'Video',
      isDirectory: false,
      isScormDir: false,
      size: 0,
      hasAiSummary: false,
      aiSummary: null,
      isBusy: false,
      isSelected: false,
      prompt: null,
      changePrompt: null,
      altText: null,
      imageLibrarySearchText: null
    } as any;
    this.selectedScene.sceneVideoFiles.push(newFile);
    this.selectedScene.selectedSceneVideoFileId = newId;
  }

  async onDeleteSceneVideoFile() {
    if (!this.selectedScene || !this.selectedScene.sceneVideoFiles) return;
    const idx = this.selectedSceneVideoFileIndex;
    const fileToDelete = this.selectedSceneVideoFile;
    if (idx >= 0) {
      // before removing the file, select next or previous file to avoid having selectedSceneVideoFileId pointing to a non-existing file
      if (idx < this.selectedScene.sceneVideoFiles.length - 1) {
        const next = this.selectedScene.sceneVideoFiles[idx + 1];
        if (next) this.selectedScene.selectedSceneVideoFileId = next.id;
      } else if (idx > 0) {
        const prev = this.selectedScene.sceneVideoFiles[idx - 1];
        if (prev) this.selectedScene.selectedSceneVideoFileId = prev.id;
      } else {
        this.selectedScene.selectedSceneVideoFileId = 0;
      }

      // Call onDeleteFileOrDirectory to remove the file from server
      await this.onDeleteFileOrDirectory(fileToDelete);
      this.selectedScene.sceneVideoFiles.splice(idx, 1);

      if (this.selectedScene.sceneVideoFiles.length === 0) {
        this.addNewSceneVideoFile();
      } else {
        // write new ids to all files
        this.selectedScene.sceneVideoFiles.forEach((f: any, idx: number) => {
          f.id = idx + 1;
        });
      }

      await this.updateSceneVideoFile();
    }
  }

  async updateSceneVideoFile() {
    if (!this.formData || !this.selectedScene) return;
    // const idx = this.selectedSceneVideoFileIndex;
    if (!this.selectedSceneVideoFile || !this.selectedSceneVideoFile.filePath) {
      this.selectedScene.previewImage = null;
      return;
    }

    try {
        // this.isBusyCreatingVideoPreviewImage = true;
      await this.saveAiVideoData();

      let params: ParamVideoScene = {
        bundleId: this.selectedBundle.id,
        elementGuid: this.syncedVideoElement.guid!,
        fileName: this.formData.fileName!,
        scene: this.selectedScene
      };
      this.selectedScene.previewImage = await rest.url("contentManager/createSceneVideoPreviewImage").post(params);

    } catch (e) {
      console.error("Error creating video preview image:", e);
    } finally {
        // this.isBusyCreatingVideoPreviewImage = false;
    }
  }

  hasPreviousSceneVideoFile() {
    return !!(this.selectedScene && this.selectedScene.sceneVideoFiles && this.selectedScene.sceneVideoFiles.length > 0 && this.selectedSceneVideoFileIndex > 0);
  }

  async selectPreviousSceneVideoFile() {
    if (!this.selectedScene || !this.selectedScene.sceneVideoFiles) return;
    const idx = this.selectedSceneVideoFileIndex;
    if (idx > 0) {
      const prev = this.selectedScene.sceneVideoFiles[idx - 1];
      if (prev) this.selectedScene.selectedSceneVideoFileId = prev.id;
    }
    await this.updateSceneVideoFile();
  }

  hasNextSceneVideoFile() {
    return !!(this.selectedScene && this.selectedScene.sceneVideoFiles && this.selectedScene.sceneVideoFiles.length > 0 && this.selectedSceneVideoFileIndex < this.selectedScene.sceneVideoFiles.length - 1);
  }

  async selectNextSceneVideoFile() {
    if (!this.selectedScene || !this.selectedScene.sceneVideoFiles) return;
    const idx = this.selectedSceneVideoFileIndex;
    if (idx < this.selectedScene.sceneVideoFiles.length - 1) {
      const next = this.selectedScene.sceneVideoFiles[idx + 1];
      if (next) this.selectedScene.selectedSceneVideoFileId = next.id;
    }
    await this.updateSceneVideoFile();
  }

  // Scenes
  addScene() {
    if (!this.formData) return;
    if (!this.formData.scenes) this.formData.scenes = [];

    const newScene = <AiVideoSceneVm> {
      id: this.formData.scenes.length > 0 ? Math.max(...this.formData.scenes.map((s) => s.id ?? 0)) + 1 : 1,
      name: "Neue Szene",
      previewImage: null,
      startFrameFiles: [],
      selectedStartFrameFileId: 0,
      sceneVideoFiles: [],
      selectedSceneVideoFileId: 0,
      imageStyle: "Photo realistic",
      scenePrompt: null,
      actorsPose: null,
      actorsDress: null,
      actorsExpression: null,
      actionPrompt: null,
      dialogText: null,
      cameraMovement: null,
      ambientOrBackgroundMusik: null,
      voiceOver: false,
      isRendered: false,
      videoUrl: null,
      extendPreviousScene: false,
      transition: "None",
      selectedFileGuidsForStartFrame: [],
      selectedFileGuidsForVideo: [],
    } as any;

    this.formData.scenes.push(newScene);

    // update ids
    this.formData.scenes.forEach((f, idx) => {
      f.id = idx + 1;
    });

    this.selectScene(this.formData.scenes.length - 1);
  }

  onDeleteScene(index: number) {
    if (!this.formData || !this.formData.scenes) return;
    // remove scene at index
    this.formData.scenes.splice(index, 1);
    // adjust selectedScene
    if (this.formData.scenes && this.formData.scenes.length > 0) {
      this.selectScene(Math.max(0, Math.min(index, this.formData.scenes.length - 1)));
    } else {
      this.selectedScene = null;
    }

    // update ids
    this.formData.scenes.forEach((f, idx) => {
      f.id = idx + 1;
    });
  }

  onReorderScene(evt: { fromIndex: number; toIndex: number }) {
    if (!this.formData || !this.formData.scenes) return;
    const from = evt.fromIndex;
    const to = evt.toIndex;
    if (from === to) return;
    const scenes = this.formData.scenes;
    // allow inserting at end (to == scenes.length)
    if (from < 0 || from >= scenes.length || to < 0 || to > scenes.length) return;
    const item = scenes.splice(from, 1)[0];
    // when inserting after the original position, adjust target index because removal shifts indices
    const adjustedTo = to > from ? to - 1 : to;
    scenes.splice(adjustedTo, 0, item);

    // update ids
    scenes.forEach((s, idx) => {
      s.id = idx + 1;
    });

    // keep selection consistent
    const selIdx = scenes.findIndex(s => s === this.selectedScene);
    if (selIdx >= 0) this.selectScene(selIdx);
  }

  onDragEndScenes(evt: any) {
    if (!this.formData || !this.formData.scenes) return;
    // update ids
    this.formData.scenes.forEach((s, idx) => {
      s.id = idx + 1;
    });

    // keep selection consistent
    const selIdx = this.formData.scenes.findIndex(s => s === this.selectedScene);
    if (selIdx >= 0) {
      this.selectScene(selIdx);
    }
  }

  selectScene(index: number) {
    if (!this.formData || !this.formData.scenes) return;
    this.selectedScene = this.formData.scenes[index] || null;

    if (this.selectedScene && (!this.selectedScene.sceneVideoFiles || this.selectedScene.sceneVideoFiles.length === 0)) {
      this.addNewSceneVideoFile();
    }

    // update file selection based on current selections
    this.selectAssetFilesForSelectedScene();
  }

  selectAssetFilesForSelectedScene() {
    if (!this.formData || !this.formData.assetFiles || !this.selectedScene) return;
    this.formData.assetFiles.forEach((file) => {
      file.isSelected = this.isVideoPanelSelected
        ? this.selectedScene!.selectedFileGuidsForVideo!.includes(file.guid!)
        : this.selectedScene!.selectedFileGuidsForStartFrame!.includes(file.guid!);
    });
  }

  imgWrapperStyle(file: any) {
    const base: any = {
      width: '158px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      cursor: 'pointer',
    };

    const isSel = !!file.isSelected;
    try {
      let accent = this.$store?.state?.ux?.colorAccent;
      if (this.isVideoPanelSelected) {
        accent = this.$store?.state?.ux?.colorAccent9;
      }
      const defaultBorder = this.darkTheme ? 'rgba(255,255,255,0.12)' : 'rgba(0,0,0,0.12)';
      // always show a subtle border
      base.border = `1px solid ${defaultBorder}`;
      base.padding = '2px';
      base.borderRadius = '8px';

      if (isSel && accent) {
        base.border = `2px solid ${accent}`;
        base.boxShadow = `0 0 0 2px ${accent}33`;
      }
    } catch (e) {
      // ignore
    }

    // dark theme background subtle
    // if (this.darkTheme) base.background = isSel ? '#2b2b2b' : 'red';

    // ensure text-field spacing
    base.boxSizing = 'border-box';

    return base;
  }

  sceneWrapperStyle(scene: any) {
    const base: any = {
      flex: '0 0 auto',
      borderRadius: '8px',
      cursor: 'pointer'
    };

    try {
      const accent = this.$store?.state?.ux?.colorAccent;
      if (this.selectedScene && this.selectedScene === scene && accent) {
        base.border = `2px solid ${accent}`;
        base.boxShadow = `0 0 0 2px ${accent}33`;
      }
    } catch (e) {
      // ignore
    }

    // adjust background for dark theme
    if (this.darkTheme) {
      base.background = '#2b2b2b90';
    } else {
      base.background = '#f0f0f0';
    }

    return base;
  }

  addScenePlaceholderStyle() {
    const borderColor = this.darkTheme ? 'rgba(255,255,255,0.12)' : 'rgba(0,0,0,0.12)';
    const bg = this.darkTheme ? '#1f1f1f' : 'transparent';
    return {
      flex: '0 0 auto',
      width: '180px',
      height: '125px',
      borderRadius: '8px',
      border: `2px dashed ${borderColor}`,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      background: bg
    };
  }

  async onDeleteFileOrDirectory(file: FileDetailsVm | null): Promise<void> {
    if (!file || !file.filePath) return;
    let params: ParamDictionary = { dictionary: {}};
    params.dictionary!["BundleId"] =  this.selectedBundle.id.toString();
    params.dictionary!["LocalPath"] = this.selectedBundle.localPath ?? "";
    params.dictionary!["RelativePath"] = '[Video] ' + this.syncedVideoElement.guid + '/';
    params.dictionary!["FileName"] = this.$globalHelper.extractFileName(file.filePath ?? "");
    params.dictionary!["IsDirectory"] = file.isDirectory.toString();

    await rest.url("contentManager/deleteFileOrDirectoryFromBundle").post(params);
  }

  get dialogBackground() {
    if (this.darkTheme)
      return "#61616190";
    else
      return "#d0d0d0";
  }
}
